const emailPattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
const numericPattern = /^-{0,1}\d*\.{0,1}\d+$/;
const ERR_INVALID_PHONENUMBER = 'ERR_INVALID_PHONENUMBER';
const ERR_PHONENUMBER_USED = 'ERR_PHONENUMBER_USED';
const ERR_IMEI_NOT_EXIST = 'ERR_IMEI_NOT_EXIST';
const ERR_IMEI_USED = 'ERR_IMEI_USED';
const ERR_VEHICLE_NOT_EXIST = 'ERR_VEHICLE_NOT_EXIST';

export default {
  ERR_INVALID_PHONENUMBER,
  ERR_PHONENUMBER_USED,
  ERR_IMEI_NOT_EXIST,
  ERR_IMEI_USED,
  ERR_VEHICLE_NOT_EXIST,

  required: value => !!value || 'Không được để trống trường này',
  min: value => value.length >= 6 || 'Vui lòng nhập tối thiểu 6 ký tự',

  numeric: value => {
    return numericPattern.test(value) || 'Vui lòng nhập số';
  },

  numericOrEmpty: value => {
    return value === ''
      ? true
      : numericPattern.test(value) || 'Vui lòng nhập số';
  },

  email: value => {
    return emailPattern.test(value) || 'Email sai định dạng';
  },

  transferVietnamese: str => {
    str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, 'a');
    str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, 'e');
    str = str.replace(/ì|í|ị|ỉ|ĩ/g, 'i');
    str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, 'o');
    str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, 'u');
    str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, 'y');
    str = str.replace(/đ/g, 'd');
    str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, 'A');
    str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, 'E');
    str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, 'I');
    str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, 'O');
    str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, 'U');
    str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, 'Y');
    str = str.replace(/Đ/g, 'D');
    str = str.replace(/[^0-9a-zàáạảãâầấậẩẫăằắặẳẵèéẹẻẽêềếệểễìíịỉĩòóọỏõôồốộổỗơờớợởỡùúụủũưừứựửữỳýỵỷỹđ\s]/gi, '');
    str = str.replace(/\s+/g, ' ');
    str = str.replace(/ /g, '');
    str.trim();
    return str;
  }
};



// WEBPACK FOOTER //
// ./src/utils/validate.js